import React, { useState } from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { Box, Grid } from '@mui/material';
import { Image, ManageAccounts } from '@mui/icons-material';
import CustomFileInput from '../../../components/Forms/CustomFileInput';
import { useDispatch } from 'react-redux';
import { colors } from '../../../assets/utils/constants';
import CustomSubmitButton from '../../../components/Forms/CustomSubmitButton';
import useRTK from '../../../hooks/useRTK';
import { useUpdateORGBannerMutation } from '../../../api/profile/profileAPI';
import { setUserProfile } from '../../../states/features/profile/profileSlice';

// ################## VALIDATION ####################
const bannerValidationSchema = Yup.object().shape({
    file: Yup.mixed().required('File field is required'),
});

// !############## MAIN FUNC ################
const UpdateBannerImage = ({ user, closeDialogy, refetchProfile }) => {
    // ################# CONST ##################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############## Comp State ##########
    // -> handle file preview
    const [filePreview, setFilePreview] = useState('');

    // ############## RTK ##################
    const [
        updateORGBanner,
        { isLoading, isSuccess, isError, error, data: updatedData },
    ] = useUpdateORGBannerMutation();

    // ############### useEffect ################
    // => RTK action
    const rtkActions = (data) => {
        closeDialogy();
        refetchProfile();
        dispatch(setUserProfile(data));
    };
    RTK.useRTKResponse(isSuccess, isError, error, updatedData, rtkActions);

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={{
                    file: '',
                }}
                validationSchema={bannerValidationSchema}
                onSubmit={(payload) => {
                    let id = user.id;
                    const data = new FormData();
                    data.append('id', id);
                    data.append('org_banner', payload.file);
                    updateORGBanner(data);
                }}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent={'center'}>
                            <Grid item sm={12}>
                                {filePreview ? (
                                    <>
                                        <img
                                            src={filePreview}
                                            alt="img"
                                            style={{
                                                width: '100%',
                                                height: '10em',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <Image
                                            sx={{
                                                width: '100%',
                                                height: '7em',
                                                objectFit: 'contain',
                                                opacity: 0.7,
                                                color: colors.bgColor5,
                                            }}
                                        />
                                    </>
                                )}
                            </Grid>
                            <Grid item sm={12}>
                                <CustomFileInput
                                    name="file"
                                    type="file"
                                    formik={formik}
                                    accept="image/*"
                                    setFilePreview={setFilePreview}
                                />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <CustomSubmitButton
                                        startIcon={<ManageAccounts />}
                                        onClick={formik.handleSubmit}
                                        variant="contained"
                                        loading={isLoading}
                                    >
                                        Update banner image
                                    </CustomSubmitButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default UpdateBannerImage;
